import React, { Dispatch, SetStateAction, useState } from "react";
import {
  MotifErrorMessage,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import Button from "@/components/Form/Button/Button";
import { AddDebtorFormType } from "./type";
import "./FormModal.scss";
import {
  compareNumeric,
  isNumeric,
  isNumericOrNull,
} from "@/utility/validation";
// import { capitalizeWordsInSentence } from "@/utility/common";
import ControlInputBoxNumber from "@/components/Form/InputBox/ControlInputBoxNumber";
import { RateTierType } from "../type";
import {
  useCreateRateTierApiMutation,
  useGetRateTierListByCaseQuery,
} from "../calculationStepReducer";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import {
  CANCEL_BUTTON_VARIANT,
  SAVE_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import {
  capitalizeAllWordsFirstChar,
  capitalizeWordsInSentence,
} from "@/utility/common";

type Props = {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  formData?: AddDebtorFormType | null;
  caseId: string;
  stepId: string;
  setIsRefetch: Dispatch<SetStateAction<boolean>>;
};

export default function FormModalRateTier({
  isVisible,
  setIsVisible,
  stepId,
  caseId,
  setIsRefetch,
}: Props) {
  const { t } = useTranslation();
  const [showMessage, setShowMessage] = useState({
    show: false,
    type: "error",
    message: "",
  });
  const { data: rateTireData } = useGetRateTierListByCaseQuery({
    CalculationStepId: stepId,
    CaseId: caseId,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleCancel, setIsVisibleCancel] = useState(false);
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isDirty },
  } = useForm<any>({
    defaultValues: {
      maxAmount: "",
      minAmount: "",
      rate: 1,
      adjustment: "",
    },
  });
  const errorList = Object.keys(errors);
  const errorsShow = capitalizeAllWordsFirstChar(
    capitalizeWordsInSentence(errorList.join(", "))
  );
  let dirtyFieldsLength = isDirty;
  // const errorList = Object.keys(errors);
  // const errorsShow = capitalizeWordsInSentence(errorList.join(", "));
  let [createRateTierApi] = useCreateRateTierApiMutation();

  // //                {errors["rate"] && errors["rate"].type === "required" && (
  //   <MotifErrorMessage>Rate is required</MotifErrorMessage>
  // )}

  const setFormat = (value: any) => {
    return value === "" || value == null || value === 0 ? null : Number(value);
  };
  function validateMinMaxTire(data: RateTierType) {
    let trig = true;
    if (data?.maxAmount === "" && data?.minAmount === "") {
      setErrorMessage(
        t(
          "pages.distributions.distributionStepsTab.rateTierTab.validationMessages.sameMaxMinValueMessage"
        )
      );
      trig = false;
    } else if (
      (data?.minAmount === "" && Number(data?.maxAmount) > 0) ||
      (data?.maxAmount === "" && Number(data?.minAmount) < 0) ||
      (Math.sign(Number(data?.maxAmount)) !==
        Math.sign(Number(data?.minAmount)) &&
        Math.sign(Number(data?.maxAmount)) !== 0 &&
        Math.sign(Number(data?.minAmount)) !== 0)
    ) {
      setErrorMessage(
        t(
          "pages.distributions.distributionStepsTab.rateTierTab.validationMessages.minMaxValueFormateMeessage"
        )
      );
      trig = false;
    } else if (compareNumeric(data?.maxAmount, data?.minAmount) < 0) {
      setErrorMessage(
        t(
          "pages.distributions.distributionStepsTab.rateTierTab.validationMessages.minvalueRangeMesaage"
        )
      );
      trig = false;
    } else {
      let maxAmount =
        data?.maxAmount !== "" &&
        data?.maxAmount !== undefined &&
        data?.maxAmount !== null
          ? Number(data?.maxAmount)
          : null;
      let minAmount =
        data?.minAmount !== "" &&
        data?.minAmount !== undefined &&
        data?.minAmount !== null
          ? Number(data?.minAmount)
          : null;
      trig = rateTireData?.find((item: any) => {
        if (item.maxAmount === maxAmount && item.minAmount === minAmount) {
          return true;
        }
        return false;
      });
      if (trig) {
        setErrorMessage(
          t(
            "pages.distributions.distributionStepsTab.rateTierTab.validationMessages.minMaxAlreadyExistsMessage"
          )
        );
      }
      trig = !trig;
    }
    if (!trig) {
      setIsLoading(false);
    }
    return trig;
  }
  const [errorMessage, setErrorMessage] = useState("");
  const onSubmit = async (data: RateTierType) => {
    setIsLoading(true);

    if (validateMinMaxTire(data)) {
      setErrorMessage("");

      try {
        let postData = {
          caseId: caseId,
          calculationStepId: stepId,
          maxAmount: setFormat(data?.maxAmount),
          minAmount: setFormat(data?.minAmount),
          rate: data?.rate,
          adjustment: data?.adjustment === "" ? null : Number(data?.adjustment),
          // rateTierGroupBy: Number(data?.rateTierGroupBy),
        };
        const responseApi: any = await createRateTierApi(postData);

        if (responseApi.hasOwnProperty("data")) {
          reset({
            //@ts-ignore
            maxAmount: "",
            //@ts-ignore
            minAmount: "",
            //@ts-ignore
            rate: 1,
            //@ts-ignore
            adjustment: "",
          });
          setIsLoading(false);
          setIsRefetch(true);
          setIsVisible(false);
        } else {
          //@ts-ignore
          const error =
            responseApi.error?.data?.message ||
            t("global.globalNotifications.unExpectedError");
          setShowMessage({
            ...showMessage,
            show: true,
            type: "error",
            message: error,
          });
          setIsLoading(false);
        }
      } catch (error) {
        setShowMessage({
          ...showMessage,
          show: true,
          type: "error",
          message: t("global.globalNotifications.unExpectedError"),
        });
      }
    }
  };
  const cancelBtnApproveHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisible(false);
    setIsVisibleCancel(false);
    reset();
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  const cancelBtnRejectHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  return (
    <>
      <MotifModal
        onClose={() => {
          if (dirtyFieldsLength) {
            setIsVisibleCancel(true);
          } else {
            setIsVisible(false);
            setIsVisibleCancel(false);
            reset();
            setShowMessage({ ...showMessage, show: false, type: "error" });
          }
        }}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        {/*@ts-ignore*/}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="formModalWrapper">
            <MotifModalHeader>
              <span className="discard_heading">
                {t(
                  "pages.distributions.distributionStepsTab.rateTierTab.formLabels.createTitle"
                )}
              </span>
            </MotifModalHeader>
            <MotifModalBody>
              <div className="formModal">
                {/* <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    <ControlSelect
                      name={"rateTierGroupBy"}
                      //@ts-ignore
                      control={control}
                      required={true}
                      showLabel={true}
                      readonly={true}
                      label={t("Type")}
                      //@ts-ignore
                      placeholder={"placeholder"}
                      options={[
                        { label: "Select Type", value: "" },
                        { label: "Creditor", value: "0" },
                        { label: "Claim", value: "1" },
                        { label: "Creditor/Assignee", value: "2" },
                      ]}
                    />
                  </div>
                </div> */}
                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    <ControlInputBoxNumber
                      name={"maxAmount"}
                      // @ts-ignore
                      control={control}
                      required={false}
                      isTextArea={false}
                      label={
                        "pages.distributions.distributionStepsTab.rateTierTab.formLabels.tierMaxAmount"
                      }
                      showLabel={true}
                      // setValue={setValue}
                      isNumber={true}
                      digitAfterDecimal={8}
                      isAmount={true}
                      onChangeAmount={() => {
                        setErrorMessage("");
                      }}
                      validate={isNumericOrNull}
                    />
                  </div>
                </div>
                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    <ControlInputBoxNumber
                      name={"minAmount"}
                      // @ts-ignore
                      control={control}
                      required={false}
                      isTextArea={false}
                      label={
                        "pages.distributions.distributionStepsTab.rateTierTab.formLabels.tierMinAmount"
                      }
                      showLabel={true}
                      // setValue={setValue}
                      isNumber={true}
                      digitAfterDecimal={8}
                      isAmount={true}
                      onChangeAmount={() => {
                        setErrorMessage("");
                      }}
                      validate={isNumericOrNull}
                    />
                  </div>
                </div>
                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    <ControlInputBoxNumber
                      name={"rate"}
                      // @ts-ignore
                      control={control}
                      required={true}
                      isTextArea={false}
                      label={
                        "pages.distributions.distributionStepsTab.rateTierTab.formLabels.rate"
                      }
                      showLabel={true}
                      // setValue={setValue}
                      isNumber={true}
                      digitAfterDecimal={8}
                      isAmount={true}
                      onChangeAmount={() => {}}
                      validate={isNumeric}
                    />
                  </div>
                </div>
                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    <ControlInputBoxNumber
                      name={"adjustment"}
                      // @ts-ignore
                      control={control}
                      required={false}
                      isTextArea={false}
                      label={
                        "pages.distributions.distributionStepsTab.rateTierTab.formLabels.adjustment"
                      }
                      showLabel={true}
                      // setValue={setValue}
                      isNumber={true}
                      digitAfterDecimal={8}
                      isAmount={true}
                      onChangeAmount={() => {}}
                      validate={isNumericOrNull}
                    />
                  </div>
                </div>
              </div>
              <div className="motif-row mar-l-5 mar-t-10">
                {errorMessage && (
                  <MotifErrorMessage>{errorMessage}</MotifErrorMessage>
                )}

                <MotifErrorMessage>
                  {showMessage.show && showMessage.message && isDirty}
                  {errorList.length > 0 &&
                    t(
                      "pages.distributions.distributionStepsTab.classFilterTab.validationMessageWithEmpty",
                      { fieldNames: errorsShow }
                    )}
                </MotifErrorMessage>
              </div>
            </MotifModalBody>
            <MotifModalFooter>
              <div className="button-container-add">
                <Button
                  variant={SAVE_BUTTON_VARIANT}
                  label={t("global.globalActions.save")}
                  loading={isLoading}
                  disabled={isLoading}
                />
                <Button
                  label={t("global.globalActions.cancel")}
                  type="button"
                  variant={CANCEL_BUTTON_VARIANT}
                  className="cancelBtn"
                  onClickHandler={() => {
                    if (dirtyFieldsLength) {
                      setIsVisibleCancel(true);
                    } else {
                      setIsVisible(false);
                      setIsVisibleCancel(false);
                      reset();
                      setShowMessage({
                        ...showMessage,
                        show: false,
                        type: "error",
                      });
                    }
                  }}
                />
              </div>
            </MotifModalFooter>
          </div>
        </form>
      </MotifModal>
      <ConfirmationModal
        isVisible={isVisibleCancel}
        setIsVisible={setIsVisibleCancel}
        cancelBtnApproveHandler={cancelBtnApproveHandler}
        cancelBtnRejectHandler={cancelBtnRejectHandler}
      />
    </>
  );
}
